// @wc-ignore-file
/**
 * Is the `@diceui/mention` suggestion menu of this input open?
 *
 * Read from the input's `aria-expanded` (diceui renders it as a combobox with
 * `aria-expanded={context.open}`) rather than mirrored through `onOpenChange`:
 * diceui fires `onOpenChange` from an effect in uncontrolled mode, and a
 * mirrored ref outlives an input unmounted with its menu open.
 *
 * Shared by the document comment text fields (CR-142) and the chat composer
 * (CR-171). `comment-submit-keys.diceui.test.tsx` pins the attribute on the
 * real diceui input.
 */
export function isMentionMenuOpen(input: Pick<Element, "getAttribute">): boolean {
  return input.getAttribute("aria-expanded") === "true";
}

/**
 * Will diceui take this Enter to pick a member? Only when its menu is open AND
 * a member is highlighted (`aria-activedescendant`, which diceui renders on the
 * input). With the menu open but nothing highlighted — no member matches —
 * diceui's Enter merely closes the menu without preventing the default.
 */
export function isMentionPickPending(input: Pick<Element, "getAttribute">): boolean {
  return isMentionMenuOpen(input) && Boolean(input.getAttribute("aria-activedescendant"));
}
